import {
  ISaleChannelForm,
  ISaleChannelMutation,
} from 'services/salesChannel/types';

export const salechannelFormToQuery = (
  values: ISaleChannelForm
): ISaleChannelMutation => {
  const { logoImageUrl, ddexStandard, file, ...salesChannel } = {
    ...values,
    isActive: !!values.isActive,
    messageRecipientId: values.messageRecipientId?.length
      ? values.messageRecipientId
      : null,
    messageRecipientName: values.messageRecipientName?.length
      ? values.messageRecipientName
      : null,
  };

  return salesChannel;
};
